var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"c-can":"'profile.experience.index'"}},[_c('work-history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }